function path(root: string, sublink: string) {
  return `${root}/${sublink}`.replace('///', '/').replace('//', '/');
}

const ROOT = '/';
const ROOT_PATH = path(ROOT, '');

export const PATH_AUTH = {
  login: path(ROOT_PATH, 'login'),
  findId: {
    root: path(ROOT_PATH, 'find-id'),
    end: path(ROOT_PATH, 'find-id/end'),
  },
  resetPwd: {
    root: path(ROOT_PATH, 'reset-pwd'),
    form: path(ROOT_PATH, 'reset-pwd/form'),
    end: path(ROOT_PATH, 'reset-pwd/end'),
  },
  register: {
    root: path(ROOT_PATH, 'register'),
    existAccount: path(ROOT_PATH, 'register/exist-account'),
    verification: {
      root: path(ROOT_PATH, 'register/verification'),
    },
    form: path(ROOT_PATH, 'register/form'),
    end: path(ROOT_PATH, 'register/end'),
  },
};

export const PATH_PAGE = {
  home: path(ROOT_PATH, '/'),
  page403: path(ROOT_PATH, '403'),
  page404: path(ROOT_PATH, '404'),
  page500: path(ROOT_PATH, '500'),
  quitSmokingDateSettings: path(ROOT_PATH, 'quit-smoking-date-settings'),

  ftnd: {
    root: path(ROOT_PATH, 'ftnd'),

    form: path(ROOT_PATH, 'ftnd/form/:ftndIndex'),
    end: path(ROOT_PATH, 'ftnd/end'),
  },
  medicalQuestion: {
    root: path(ROOT_PATH, 'medical-question'),

    form: path(ROOT_PATH, 'medical-question/form'),
    end: path(ROOT_PATH, 'medical-question/end'),
  },
  drugQuestion: {
    root: path(ROOT_PATH, 'drug-question'),

    form: path(ROOT_PATH, 'drug-question/form'),
  },
  medicineSettings: {
    root: path(ROOT_PATH, 'medicine-settings'),
  },
  drJin: {
    root: path(ROOT_PATH, 'drJin'),
  },
  mission: {
    root: path(ROOT_PATH, 'mission'),
    history: path(ROOT_PATH, 'mission/history'),
    historyDetail: path(ROOT_PATH, 'mission/history-detail/:targetWeek'),
    detail: path(ROOT_PATH, 'mission/detail'),
  },
  craving: {
    root: path(ROOT_PATH, 'craving'),
    record: {
      root: path(ROOT_PATH, 'craving/record/:step'),
      end: path(ROOT_PATH, 'craving/record-end'),
    },
  },
  calendar: {
    root: path(ROOT_PATH, 'calendar'),
    quitSmokingDiary: path(ROOT_PATH, 'calendar/quit-smoking-diary/:selectedDate'),
    editQuitSmokingDiary: path(ROOT_PATH, 'calendar/edit-quit-smoking-diary/:selectedDate'),
    cravingDiary: path(ROOT_PATH, 'calendar/craving-diary/:selectedDate'),
    quitSmokingAim: path(ROOT_PATH, 'calendar/quit-smoking-aim'),
  },
  myPage: {
    root: path(ROOT_PATH, 'my-page'),
    edit: {
      profile: path(ROOT_PATH, 'my-page/edit-profile'),
      memberInfo: path(ROOT_PATH, 'my-page/edit-member-info'),
    },
    settings: {
      terms: path(ROOT_PATH, 'my-page/terms-settings'),
      termsDetail: path(ROOT_PATH, 'my-page/terms-settings/detail'),
      notification: path(ROOT_PATH, 'my-page/notification-settings'),
      language: path(ROOT_PATH, 'my-page/language-settings'),
    },
    customerService: {
      faq: path(ROOT_PATH, 'my-page/customer-service/faq'),
      version: path(ROOT_PATH, 'my-page/customer-service/version'),
      appGuide: path(ROOT_PATH, 'my-page/customer-service/app-guide'),
    },
    withdrawal: path(ROOT_PATH, 'withdrawal'),
  },
  policy: path(ROOT_PATH, 'policy'),
  supporter: path(ROOT_PATH, 'supporter'),
  notification: path(ROOT_PATH, 'notification'),
};
